/** @jsx jsx */
import { jsx } from '@emotion/core';

import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import compose from 'lodash/fp/compose';
import get from 'lodash/get';
import defaultsDeep from 'lodash/defaultsDeep';
import { Icon } from '../../../ui/Icon';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles';
import { withNamespaces } from 'react-i18next';

const defaultData = {
  TopLocationMenu: { value: [] },
};

import { Row, Column } from '../../../../styles/Grid';
import {
  NavConsumer,
  navbar_finite_state,
} from '../../../../contexts/NavContext';

class NewTopLocationMenu extends SafePureComponent {
  fields = defaultsDeep(get(this, 'props.fields'), defaultData);
  state = { windowWidth: 0 };

  goBack = () => {
    this.props.onClickBackButton();
  };

  renderSubList = items => {
    return (
      items &&
      items.map((item, index) => (
        <div key={`list-data-` + index} css={[styles.subItems]}>
          <a href={item.Url} title={item.Text} className="sub-item-anchor">
            <span>{item.Text}</span>
          </a>
        </div>
      ))
    );
  };

  renderList = items => {
    const { SeoList } = this.props;
    const SitemapUrl = get(SeoList, 'SitemapUrl', '');

    return items.map((item, index) => {
      let haveSubData = SitemapUrl && parseInt(item.Count, 10) > 0;
      return (
        <Column
          key={`list-data-` + index}
          cols={{ lg: 2, md: 3, sm: 6, xs: 6, xl: 2 }}
          css={[styles.topItemsbase]}
        >
          <div css={[styles.subItemshead]}>
            <a href={item.Url} title={item.Text} className="top-anchor">
              <span>{item.Text}</span>
            </a>

            {haveSubData && (
              <span className="sub-item-count">
                <a href={SitemapUrl}>See all ({item.Count})</a>
              </span>
            )}

            {this.renderSubList(item.SubItems)}
          </div>
        </Column>
      );
    });
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  renderRowGrid = (items, SitemapUrl) => {
    const { isFromNav } = this.props;
    return (
      <Row css={[styles.gridlist, isFromNav && styles.gridlistScroll]}>
        <div className="gridlistsec">{this.renderList(items, SitemapUrl)}</div>
        {isFromNav && <div css={[styles.shadowscroll]}></div>}
      </Row>
    );
  };

  renderAccordian = items => {
    const { isFromNav, SeoList } = this.props;
    const SitemapUrl = get(SeoList, 'SitemapUrl', '');
    let url = '';
    if (typeof window != undefined) {
      url = window.location.origin + SitemapUrl;
    }
    return (
      <Accordion
        allowZeroExpanded
        css={[styles.accordionStyle, isFromNav && styles.accordionScrollStyle]}
      >
        <div>
          {items.map((item, index) => {
            let haveSubData = SitemapUrl && parseInt(item.Count, 10) > 0;
            return (
              <AccordionItem key={`list-data-` + index}>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="left-part">
                      <a href={item.Url} title={item.Text}>
                        <span>{item.Text}</span>
                      </a>
                      {haveSubData && (
                        <span className="sub-item-count">
                          <a href={url}>See all ({item.Count})</a>
                        </span>
                      )}
                    </div>
                    {haveSubData && (
                      <div className="right-part">
                        <span className="icon-holder">
                          <Icon name="chevron-down" />
                        </span>
                      </div>
                    )}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  {this.renderSubList(item.SubItems)}
                </AccordionItemPanel>
              </AccordionItem>
            );
          })}
        </div>
        {isFromNav && <div css={[styles.shadowscroll]}></div>}
      </Accordion>
    );
  };

  safeRender() {
    const { windowWidth } = this.state;
    const { SeoList, isFromNav } = this.props;

    let styleGoBackbtn = [styles.goBackButtonContainer];
    if (windowWidth <= 600) {
      styleGoBackbtn.push(styles.goBackMobileButtonContainer);
    }

    return (
      <div css={[styles.bglight, isFromNav && styles.setPadding]}>
        <div css={[styles.mainlistsection]}>
          <NavConsumer>
            {({ closeModal, openModal }) => (
              <div className="back_close_sec">
                <div css={styleGoBackbtn}>
                  <button
                    css={styles.goBackButton}
                    onClick={() => {
                      if (isFromNav) {
                        openModal({
                          target: {
                            dataset: {
                              id: navbar_finite_state.WAYS_TO_WORK,
                            },
                          },
                        });
                      } else {
                        window.history.back();
                      }
                    }}
                  >
                    <Icon name="arrow-left" />
                    <span css={styles.goBackButtonLabel}>Back</span>
                  </button>
                </div>
                {isFromNav && (
                  <div css={styleGoBackbtn}>
                    <button css={styles.closeButton} onClick={closeModal}>
                      <i className="icon-closer" />
                      <span css={styles.goBackButtonLabel}>Close</span>
                    </button>
                  </div>
                )}
              </div>
            )}
          </NavConsumer>

          {/* <div className="headingSec">
            <h2>Our locations around the world</h2>
          </div> */}

          {SeoList.NavHeading && (
            <div css={[styles.sectionTitle]}>
              <h2>
                {SeoList.NavHeading}
                {/* <DotComponent></DotComponent> */}
              </h2>
            </div>
          )}

          {windowWidth <= 600
            ? this.renderAccordian(SeoList.Items)
            : this.renderRowGrid(SeoList.Items, SeoList.SitemapUrl)}
        </div>
      </div>
    );
  }
}

NewTopLocationMenu.displayName = 'NewTopLocationMenu';

export default compose(
  withNamespaces(),
  withSitecoreContext(),
)(NewTopLocationMenu);
